import { cn } from '@/lib/utils';
import { resolveOcrContainerIdPrefix } from '../utils/container-label';

interface ContainerIdPrefixProps {
  id: number | null | undefined;
  className?: string;
}

/**
 * The container's id ahead of its name — `55- REG-2026-167` (OMA-670).
 *
 * Styled apart from the name so the two never read as one string. It is a
 * sibling of the name rather than part of it: the name carries its own
 * direction (`dir='auto'`), the prefix follows the page's, so it always sits at
 * the start of the reading direction — left in English, right in Arabic.
 */
export function ContainerIdPrefix({ id, className }: ContainerIdPrefixProps) {
  const prefix = resolveOcrContainerIdPrefix(id);

  if (!prefix) return null;

  return (
    <span className={cn('inline-flex shrink-0 items-center', className)}>
      <span
        dir='ltr'
        className='text-primary font-mono font-semibold tabular-nums'
      >
        {prefix}
      </span>
      <span className='text-muted-foreground'>-</span>
    </span>
  );
}
